import SearchForm from "../components/SearchForm";
import DailyWeatherList from "../components/DailyWeatherList";

export default function Home() {
    
    return (
        <>
            <SearchForm />
            <DailyWeatherList />
        </>
    )
}